import { querySpsPageList } from '@/graphql/holdings'
import { useLazyQuery } from '@vue/apollo-composable'
import { useStore } from 'vuex'
import storage, { StorageType } from '@/utils/storage'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'

export default function useSps() {
  const store = useStore()
  const { load, onResult, loading, refetch } = useLazyQuery(querySpsPageList)

  onResult((res) => {
    const { otherPosPageList, clientLifecycle } = res.data
    if (otherPosPageList.ok) {
      store.commit(HoldingsMutationTypes.SET_SPS_POS_PAGE_LIST, otherPosPageList.data)
    }
    if (clientLifecycle.ok) {
      store.commit(HoldingsMutationTypes.SET_CLIENT_LIFECYCLE, clientLifecycle.data)
    }
  })

  const querySpsData = () => {
    const fundAccount = storage.rcGetItem(StorageType.local, 'userInfo')
    const param = {
      stockPos: {
        exchangeType: 'SPS',
        fundAccount
      },
      lifecycle: {
        clientId: fundAccount,
        productType: 'FCN'
      }
    }
    // eslint-disable-next-line
    // @ts-ignore
    load(querySpsPageList, param) || refetch({ filter: param })
  }
  return { querySpsData, onResult, loading }
}
